import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  registerOfflineNavigator,
  unregisterOfflineNavigator,
} from "services/api";
import { Routes } from "ui/modules/public/navigation";

export const OfflineNavigatorBinder = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registerOfflineNavigator(() => {
      if (window.location.pathname !== Routes.OfflinePage) {
        navigate(Routes.OfflinePage);
      }
    });
    return unregisterOfflineNavigator;
  }, [navigate]);

  return null;
};

export default OfflineNavigatorBinder;
